"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePickerDay = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _DatePickerDay = require("../components/DatePickerDay");
var _datePickerTheme = require("./datePickerTheme");
const DateRangePickerDay = (0, _styled.default)(_DatePickerDay.DatePickerDay)`
    ${_ref => {
  let {
    focusMode,
    isEnd,
    isStart,
    rangeIsSelected,
    themeMode
  } = _ref;
  return !rangeIsSelected && (isEnd || isStart) ?
  // If the user is in the process of selecting a start/end, we want to highlight the
  // start/end day so the little ::before element we use to fill out the start/end
  // background doesn't show if the user moves their cursor off the latest hovered
  // start/end.
  {
    backgroundColor: _datePickerTheme.datePickerTheme.dayBackgroundColorHover[themeMode],
    // The Ursa theme sets a different background color when selecting a range by keyboard.
    ":focus": focusMode === "keyboard" ? {
      backgroundColor: _datePickerTheme.datePickerTheme.dayBackgroundColorFocusedSelecting[themeMode]
    } : {}
  } : "";
}}
    ${_ref2 => {
  let {
    isDisabled
  } = _ref2;
  return isDisabled ? `background-color: transparent;` : "";
}}
`;
exports.DateRangePickerDay = DateRangePickerDay;
//# sourceMappingURL=DateRangePickerDay.js.map